var _br, _Glyphicon, _InformationCircleIco, _CameraIcon;
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import clsx from 'clsx';
import { CameraIcon, InformationCircleIcon } from '@iris/react-icons';
import { sendClick } from 'reaxl-analytics';
import { ownerEmailClick } from 'reaxl-analytics-handlers';
import { Button, Glyphicon, IconButton } from 'reaxl';
import EmailStaticContent from '../EmailStaticContent';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const bsStyleMap = {
  link: 'text',
  'link-decorated': 'text-decorated',
  'link-decorated-inverse': 'text-decorated-inverse',
  'link-inverse': 'text-inverse'
};

/**
 *  EmailCTA is a component that renders Confirm Availability link or button, Email Dealer link or button (Alpha dealer tile and DDP)
 */
function EmailCTA(_ref) {
  let {
    buttonStyle = 'primary',
    buttonSize,
    className,
    clickType = '',
    context = '',
    labelKey,
    listingId,
    onClick,
    onBuildClick,
    ownerId = '',
    parentId = 'v_lstg',
    type = 'button',
    showIcon = true,
    isPrivateSeller = false,
    allowPropagation = false,
    ...rest
  } = _ref;
  const isIcon = type === 'icon';
  const isLink = ['link', 'link-decorated', 'link-decorated-inverse', 'link-inverse'].includes(type);
  const showArrowIcon = ['creditStatus', 'viewAvailableOffers'].includes(labelKey);
  const isPreorder = labelKey === 'quote';
  const isSlider = labelKey === 'morePhotos' || labelKey === 'moreInfo';
  if (isIcon) {
    showIcon = true;
  }
  let labelValue = listingId ? EmailStaticContent.cta.listing : EmailStaticContent.cta.dealer;
  if (EmailStaticContent.cta[labelKey]) {
    labelValue = EmailStaticContent.cta[labelKey].split('\n').reduce((acc, line) => /*#__PURE__*/_jsxs(_Fragment, {
      children: [acc, _br || (_br = /*#__PURE__*/_jsx("br", {})), line]
    }));
  }
  const handleClick = useCallback(event => {
    if (!allowPropagation) event.stopPropagation(); // for cta's embedded in linked components
    event.currentTarget.blur();
    onClick(context || labelKey); // show email modal and pass context value to email modal (ConnectedEmailOwner)

    const submittedCalculatorContext = labelKey === 'calculatorDealSubmitted' ? 'calulator' : '';
    sendClick(ownerEmailClick, event, {
      clickType,
      par: parentId,
      includePageId: context !== 'quick',
      inventoryId: listingId,
      ownerId,
      context: submittedCalculatorContext || context || labelKey // use labelKey if context is not specified
    });
  }, [onClick, labelKey, clickType, parentId, listingId, ownerId, context, allowPropagation]);
  if (['iconbutton', 'iconbutton-horizontal'].includes(type)) {
    return /*#__PURE__*/_jsx(IconButton, {
      "data-cmp": "emailCTA",
      glyph: "envelope",
      label: labelValue,
      layout: type === 'iconbutton' ? 'stacked' : 'horizontal',
      onClick: handleClick,
      rel: "nofollow noopener",
      size: type === 'iconbutton' ? 'large' : 'medium',
      target: "_blank"
    });
  }
  const buttonClassNames = clsx({
    'text-size-100 text-size-lg-200': context === 'compare',
    'padding-0': isIcon,
    // align email icon with button label
    'display-flex justify-content-center align-items-center': showIcon && !isIcon && !isPreorder
  });
  const iconClassNames = clsx({
    'margin-right-2 text-size-500': !isIcon,
    'text-accent text-size-700': isIcon
  });
  const renderButtonCTAs = /*#__PURE__*/_jsxs(Button, {
    className: buttonClassNames,
    bsStyle: buttonStyle,
    bsSize: buttonSize,
    onClick: handleClick,
    block: type === 'block',
    ...(isIcon && {
      'aria-label': labelValue
    }),
    children: [showIcon && /*#__PURE__*/_jsx(Glyphicon, {
      glyph: "envelope",
      "aria-hidden": "true",
      className: iconClassNames
    }), !isIcon && labelValue]
  });
  return /*#__PURE__*/_jsxs("div", {
    className: className,
    "data-cmp": "emailCTA",
    ...rest,
    children: [isLink && /*#__PURE__*/_jsxs(Button, {
      bsStyle: bsStyleMap[type] || 'text',
      block: true,
      onClick: handleClick,
      children: [labelValue, showArrowIcon && (_Glyphicon || (_Glyphicon = /*#__PURE__*/_jsx(Glyphicon, {
        glyph: "chevron-right",
        "aria-hidden": "true",
        className: "margin-left-1"
      })))]
    }), isSlider && /*#__PURE__*/_jsxs(Button, {
      bsStyle: "text",
      className: "display-flex flex-column",
      onClick: handleClick,
      children: [labelKey === 'moreInfo' ? _InformationCircleIco || (_InformationCircleIco = /*#__PURE__*/_jsx(InformationCircleIcon, {
        className: "iris-icon margin-bottom-2"
      })) : _CameraIcon || (_CameraIcon = /*#__PURE__*/_jsx(CameraIcon, {
        className: "iris-icon margin-bottom-2"
      })), labelValue]
    }), !isLink && !isSlider && !isPrivateSeller && renderButtonCTAs]
  });
}
export default EmailCTA;